<template>
  <section class="container-section">
    <div class="sub-container">
      <loading
        :active="isLoading"
        :is-full-page="true"
      />
      <section class="section-titles uk-padding-remove">
        <h3 class="title">
          Gestión aeroportuaria
        </h3>
      </section>
      <section>
        <div class="list-items">
          <div class="items">
            <label style="cursor: pointer">
              <input
                v-model="airportManagementImport.airportTaxesAndRampHandling"
                class="uk-checkbox"
                type="checkbox"
              > Tasas aeroportuarias y handling de rampa
            </label>
          </div>

          <div class="items">
            <label style="cursor: pointer">
              <input
                v-model="airportManagementImport.rXinspectionExpenses"
                class="uk-checkbox"
                type="checkbox"
              >  Gastos por Inspección R-X
            </label>
          </div>

          <div class="items">
            <label style="cursor: pointer">
              <input
                v-model="airportManagementImport.servicesHandler"
                class="uk-checkbox"
                type="checkbox"
              > Servicios Cargo Handler > 24 Horas
            </label>
          </div>

          <div
            class="uk-flex items uk-flex-wrap"
          >
            <div class="uk-margin-right uk-flex uk-flex-column uk-flex-center">
              <label style="cursor: pointer">
                <input
                  v-model="airportManagementImport.forkliftService"
                  class="uk-checkbox"
                  type="checkbox"
                  @change="airportManagementImport.forkliftServiceMinutes = 0"
                > Servicio de montacargas
              </label>
            </div>
            <div
              class="uk-flex"
              style="margin-top: 5px"
            >
              <input
                v-model="airportManagementImport.forkliftServiceMinutes"
                :disabled="!airportManagementImport.forkliftService"
                min="0"
                max="9999"
                class="uk-input uk-form-width-xsmall"
                style="width: 70px; margin-right: 5px"
                type="number"
                @keydown="$helperPlugin.onlyNumber($event)"
              >
              <label class=" uk-flex uk-flex-column uk-flex-center"> Tiempo en minutos</label>
            </div>
          </div>

          <div
            class="uk-flex items uk-flex-wrap"
          >
            <div class="uk-margin-right uk-flex uk-flex-column uk-flex-center">
              <label style="cursor: pointer">
                <input
                  v-model="airportManagementImport.usePalletJack"
                  class="uk-checkbox"
                  type="checkbox"
                  @change="airportManagementImport.usePalletJackHours = 0"
                > Uso de pallet jack
              </label>
            </div>
            <div
              class="uk-flex"
              style="margin-top: 5px"
            >
              <input
                v-model="airportManagementImport.usePalletJackHours"
                :disabled="!airportManagementImport.usePalletJack"
                min="0"
                max="9999"
                class="uk-input uk-form-width-xsmall"
                style="width: 70px; margin-right: 5px"
                type="number"
                @keydown="$helperPlugin.onlyNumber($event)"
              >
              <label class=" uk-flex uk-flex-column uk-flex-center"> Tiempo en Horas</label>
            </div>
          </div>

          <div class="items">
            <label style="cursor: pointer">
              <input
                v-model="airportManagementImport.truckStowage"
                class="uk-checkbox"
                type="checkbox"
              > Estiba camión
            </label>
          </div>

          <div
            class="items uk-margin-remove"
            style="width: 100%"
          >
            <label
              class="uk-margin-right"
              style="cursor: pointer"
            >
              <input
                v-model="airportManagementImport.warehouseManagementCheck"
                class="uk-checkbox"
                type="checkbox"
                @change="resetAirportManagement(airportManagementImport.warehouseManagementCheck)"
              > Servicios de Almacén Adicionales
            </label>
            <span class="uk-margin-remove">
              <select
                v-model="airportManagementImport.warehouseManagement"
                :disabled="airportManagementImport.warehouseManagementCheck == null || airportManagementImport.warehouseManagementCheck == false"
                class="uk-select uk-form-width-medium"
                style="margin: 5px 10px 0px 0px"
                @change="resetAirportManagement(airportManagementImport.warehouseManagement)"
              >
                <option
                  v-for="wareManagement in wareManagements"
                  :key="wareManagement.id"
                  :value="wareManagement.id"
                >
                  {{ wareManagement.description }}
                </option>
              </select>
              <span
                v-if="airportManagementImport.warehouseManagement == '3'"
                class="workout-min"
              >
                <input
                  v-model="airportManagementImport.warehouseManagementLaborUseMinutes"
                  class="uk-input uk-form-width-xsmall"
                  style="width: 60px; margin: 5px 0px 0px 0px !important"
                  type="number"
                  min="0"
                  max="9999999"
                  @keydown="$helperPlugin.onlyNumber($event)"
                > Minutos
              </span>
              <span
                v-else
                class="opt"
              >(Opcional)
              </span>
            </span>
            <div
              v-if="airportManagementImport.warehouseManagement == '1'"
              style="margin: 10px 0px"
            >
              <label style="cursor: pointer">
                Días de Almacenaje
                <input
                  v-model="airportManagementImport.storageDays"
                  class="uk-input uk-form-width-small uk-margin-left"
                  type="number"
                  min="0"
                  max="9999999"
                  @keydown="$helperPlugin.onlyNumber($event)"
                >
              </label>
            </div>
          </div>
        </div>
      </section>

      <section
        v-if="dollyTypeEnum.dryLoad === dollyType"
        class="list-items"
      >
        <div
          v-if="dryLoadOff"
          class="uk-flex items uk-flex-wrap"
        >
          <div class="uk-margin-right uk-flex uk-flex-column uk-flex-center">
            <label style="cursor: pointer">
              <input
                v-model="receptionLogistics.nonReeferWarerhouse"
                class="uk-checkbox"
                type="checkbox"
                @change="receptionLogistics.warerhouseDays = null"
              > Almacenamiento carga seca
            </label>
          </div>
          <div
            class="uk-flex"
            style="margin-top: 5px"
          >
            <input
              v-model="receptionLogistics.warerhouseDays"
              :disabled="!receptionLogistics.nonReeferWarerhouse"
              min="0"
              class="uk-input uk-form-width-xsmall"
              style="width: 70px; margin-right: 5px"
              type="number"
              max="9999"
              @keydown="$helperPlugin.onlyNumber($event)"
            >
            <label class=" uk-flex uk-flex-column uk-flex-center"> No. de días</label>
          </div>
        </div>
        <div
          v-if="reeferdOff"
          class="uk-flex items uk-flex-wrap"
        >
          <div class="uk-margin-right uk-flex uk-flex-column uk-flex-center">
            <label style="cursor: pointer">
              <input
                v-model="receptionLogistics.refrigeratedStorage"
                class="uk-checkbox"
                type="checkbox"
                @change="receptionLogistics.warerhouseDays = null"
              > Almacenamiento refrigerado
            </label>
          </div>
          <div
            class="uk-flex"
            style="margin-top: 5px"
          >
            <input
              v-model="receptionLogistics.warerhouseDays"
              :disabled="!receptionLogistics.refrigeratedStorage"
              min="0"
              class="uk-input uk-form-width-xsmall"
              style="width: 70px; margin-right: 5px"
              type="number"
              max="9999999"
              @keydown="$helperPlugin.onlyNumber($event)"
            >
            <label class=" uk-flex uk-flex-column uk-flex-center"> No. de días</label>
          </div>
        </div>

        <div class="items">
          <label style="cursor: pointer">
            <input
              v-model="receptionLogistics.valueAddedServices"
              name="valueAddedServices"
              class="uk-checkbox"
              type="checkbox"
              tooltip="Value added services"
            > Servicio de valor añadido
          </label>
        </div>

        <div class="items">
          <label style="cursor: pointer">
            <input
              v-model="receptionLogistics.warehouseEnvironmentTransport"
              name="warehouseEnvironmentTransport"
              class="uk-checkbox"
              type="checkbox"
            > Transporte entorno Almacén
          </label>
        </div>

        <div class="items">
          <label style="cursor: pointer">
            <input
              v-model="receptionLogistics.customsBroker"
              name="customsBroker"
              class="uk-checkbox"
              type="checkbox"
            > Agencia aduanal
          </label>
        </div>

        <div class="items">
          <label style="cursor: pointer">
            <input
              v-model="receptionLogistics.merchandiseHandlingClearance"
              name="merchandiseHandlingClearance"
              class="uk-checkbox"
              type="checkbox"
            > Manejo de mercancía <span class="opt">(despacho)</span>
          </label>
        </div>
        <div
          v-if="receptionLogistics.isCarriageVergeConsolidation == true"
        >
          <div
            class="items"
          >
            <label class="uk-margin">
              <input
                v-model="receptionLogistics.averageHaulingDistance"
                class="uk-input uk-form-width-small"
                type="number"
                min="0"
                max="9999999"
                @keydown="$helperPlugin.onlyDecimal($event)"
              >
              -Km (Distancia Promedio de Acarreo)
            </label>
          </div>
          <div
            class="items"
          >
            <label>
              <input
                v-model="receptionLogistics.TravelCarriageNecessary"
                class="uk-input uk-form-width-small"
                type="number"
                min="0"
                max="9999999"
                @keydown="$helperPlugin.onlyNumber($event)"
              >
              -No. Viajes Acarreos Necesarios
            </label>
          </div>
        </div>
      </section>
    </div>
    <div class="btn">
      <wizard-button />
    </div>
  </section>
</template>

<script>
import { transportModeTypeEnum, dollyTypeEnum, directionTypeEnum } from '../../../../types'
import { mapGetters } from 'vuex'
export default {
  data () {
    return {
      transportModeTypeEnum,
      dollyTypeEnum,
      directionTypeEnum,
      dryLoadOff: null,
      reeferdOff: null,

      airportManagementImport: {
        airportTaxesAndRampHandling: null,
        rXinspectionExpenses: null,
        warehouseManagementCheck: null,
        warehouseManagementLaborUseMinutes: 0,
        warehouseManagement: null,
        storageDays: 0,
        servicesHandler: null,
        forkliftService: null,
        forkliftServiceMinutes: null,
        usePalletJack: null,
        usePalletJackHours: null,
        truckStowage: null
      },

      receptionLogistics: {
        nonReeferWarerhouse: null,
        refrigeratedStorage: null,
        warerhouseDays: null,
        valueAddedServices: null,
        warehouseEnvironmentTransport: null,
        customsBroker: null,
        merchandiseHandlingClearance: null,
        travelCarriageNecessary: null,
        averageHaulingDistance: null
      },

      wareManagements: [],
      isLoading: false

    }
  },

  computed: {
    ...mapGetters([
      'airportManagementStore',
      'receptionLogisticsStore',
      'transportMode',
      'dollyType',
      'journeyDirection'
    ])
  },

  watch: {
    'airportManagementImport.forkliftServiceMinutes': async function (newVal, oldVal) {
      if (newVal > 9999) {
        this.airportManagementImport.forkliftServiceMinutes = oldVal
      }
      oldVal = this.airportManagementImport.forkliftServiceMinutes
    },

    'airportManagementImport.usePalletJackHours': async function (newVal, oldVal) {
      if (newVal > 9999) {
        this.airportManagementImport.usePalletJackHours = oldVal
      }
      oldVal = this.airportManagementImport.usePalletJackHours
    },
    'receptionLogistics.warerhouseDays': async function (newVal, oldVal) {
      if (newVal > 9999) {
        this.receptionLogistics.warerhouseDays = oldVal
      }
      oldVal = this.receptionLogistics.warerhouseDays
    },
    airportManagementImport: {
      handler: function (newVal) {
        this.$store.commit('setAirportManagement', newVal)
      },
      deep: true
    },
    receptionLogistics: {
      handler: function (newVal) {
        this.$store.commit('setReceptionLogistics', newVal)
      },
      deep: true
    }
  },

  async mounted () {
    await this.init()
    this.airportManagementImport = { ...this.airportManagementStore }
    this.receptionLogistics = { ...this.receptionLogisticsStore }
  },

  methods: {
    async init () {
      this.isLoading = true
      try {
        const data = await this.$services.transportChainScenarioService.getChoices()
        const coldRooms = 2
        this.wareManagements = data.warehouseManagements.filter(x => x.id !== coldRooms)
        this.isDryLoad()
        this.isReefer()
      } catch (ex) {
        console.log(ex)
      }
      this.isLoading = false
    },
    isDryLoad () {
      if ((this.transportMode === this.transportModeTypeEnum.maritime || this.transportMode === this.transportModeTypeEnum.aerial) && this.journeyDirection === this.directionTypeEnum.import && this.dollyType === this.dollyTypeEnum.reefer) {
        this.dryLoadOff = false
      } else {
        this.dryLoadOff = true
      }
    },
    isReefer () {
      if ((this.transportMode === this.transportModeTypeEnum.maritime || this.transportMode === this.transportModeTypeEnum.aerial) && this.journeyDirection === this.directionTypeEnum.import && this.dollyType === this.dollyTypeEnum.dryLoad) {
        this.reeferdOff = false
      } else {
        this.reeferdOff = true
      }
    },
    resetAirportManagement (airportManagement) {
      if (airportManagement === 3) {
        this.airportManagementImport.storageDays = null
      }
      if (airportManagement === 1) {
        this.airportManagementImport.warehouseManagementLaborUseMinutes = null
      }
      if (airportManagement === null || airportManagement === false) {
        this.airportManagementImport.storageDays = null
        this.airportManagementImport.warehouseManagementLaborUseMinutes = null
        this.airportManagementImport.warehouseManagement = 0
      }
    }
  }

}
</script>

<style scoped>
p {

  margin: 10px;
}
.uk-padding{
  padding-top: 5px;
  padding-right: 5px;
}
.container-section{
  padding: 10px 40px;
}

.sub-container{
  min-height: 418px;;
}
section{
  width: 98%;
  padding: 10px 10px 10px;
}

.title{
  margin-bottom: 10px;
}
.section-titles{
  width: 85%;
}
.btn{
  padding-right:25px ;
}

.opt{
  font-size: 12px;
  color: rgb(151, 151, 151);
  margin: 0px
}
.workout-min{

  display: inline-block;
}

.list-items{
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  margin-right: 40px;
}

.items{
  margin: 0px 60px 30px 0px;
  min-width: 240px;
}

@media screen and (max-width: 879px){

  .section-titles{
    width: 100%;
    padding: 0px;
  }
  .items{
     margin: 0px 40px 20px 0px;
     min-width: auto;
  }
  .main{
    padding-top: 25px ;
  }
  .title{
    font-size: 17px;
  }
  .helper{
    font-size: 11px;
  }
  *{
    font-size: 12px;
  }
  .container-section{
  padding: 10px 20px;
}
   .workout-min{
    display: block;
    margin: 5px 0px !important;
  }
}

@media screen and (max-width: 689px){
  .title{
    font-size: 13px;
    margin-bottom: 5px;

  }
  *{
    font-size: 10px;
  }
  .opt{
    font-size: 10px;
  }

  .helper{
    font-size: 10px;
  }
  .items{
    min-width: auto;
  }

}
@media screen and (max-width: 399px){

  .uk-select{
    width: 160px;
    padding: 2px;
  }
  .items{
    min-width: 220px;
  }
}

</style>
